interface ILoggerService {
    log(error: any)
}

export class LoggerService implements ILoggerService {
    log(error: any) {
        if (error && error.data && error.data.Message || typeof error === 'string') console.error(error)
        else console.log(error)
    }
}